<template>
    <div class="pdfpage portrait">
        <h3 class="pageTitle" style="opacity: 0.0">2022年{{divname}}{{typeText}}预算</h3>
    </div>
    <div class="pdfpage portrait">
        <p v-for="(e,index) in $store.state.errors" :key="index" class="error">{{e.message}}</p>
        <span class="pageTitle">
            <span id="pageTitle">{{divname}}</span>2022年{{typeText}}预算
            <span v-if="port=='2617'" style="color:red"><br />（内部预览版）</span>
        </span>

    </div>
    <div class="pdfpage portrait direList">
        <h3 class="catalogue">目&nbsp;&nbsp;录</h3>
        <h4>第一部分&nbsp;{{typeText}}概况</h4>
        <p>一、主要职能</p>
        <p>二、{{typeText}}预算单位构成</p>
        <h4>第二部分&nbsp;{{typeText}}预算表</h4>
        <p v-for="(item,index) in tableTitle" :key="index">
            {{intToChinese(index+1)}}、{{item.title}}
        </p>
        <h4>第三部分&nbsp;{{typeText}}预算情况说明</h4>
        <h4>第四部分&nbsp;名词解释</h4>
    </div>
    <div class="pdfpage portrait pdfqksm">
        <h3 class="catalogue">第一部分&nbsp;&nbsp;{{typeText}}概况</h3>
        <deptSurvey :qksmData="qksm" v-if="isData"></deptSurvey>
    </div>
    <div v-for="(item,index) in subjectCofig" :key="index" :class="item.transverse ? 'table pdfpage landscape' : 'pdfpage portrait'" v-if="isData">
        <h3 v-if="index==0" class="catalogue">第二部分&nbsp;&nbsp;{{typeText}}预算表</h3>
        <tableindex :pdfmoreDetails="moreDetails" :pdfthreeLines="threeLines" :pdfsubjectCofig="subjectCofig" :pdfdataJson="dataJson" :tablenum="index"></tableindex>
    </div>
    <div class="pdfpage portrait pdfqksm">
        <h3 class="catalogue">第三部分&nbsp;&nbsp;{{typeText}}预算情况说明</h3>
        <qksm1 :T1="exprList['T1']" v-if="isData"></qksm1>
        <qksm2 :T2="exprList['T2']" v-if="isData"></qksm2>
        <qksm3 :T3="exprList['T3']" v-if="isData"></qksm3>
        <qksm4 :T4="exprList['T4']" v-if="isData"></qksm4>
        <qksm5 :T5="exprList['T5']" v-if="isData"></qksm5>
        <qksm6 :T6="exprList['T6']" v-if="isData"></qksm6>
        <qksm7 :T7="exprList['T7']" v-if="isData"></qksm7>
        <qksm8 :T8="exprList['T8']" v-if="isData"></qksm8>
        <qksm9 :T6="exprList['T6']" v-if="isData"></qksm9>
    </div>
    <div class="pdfpage portrait">
        <h3 class="catalogue">第四部分&nbsp;&nbsp;名词解释</h3>
        <div id="isData" style="height: 0px; line-height: 0px;">{{isFinish}}</div>
        <mcjs :qksmData="qksm" :tableData="tables" :bdata="bdata" v-if="isData"></mcjs>
    </div>
</template>

<script>
    let host = window.location.host
    let hostCity = host.slice(0, host.indexOf("."))
    let openYear = Number('20' + host.split(".")[1].substring(0, 2))
    let openType = host.split(".")[1].substring(2, 4)
    import $ from "jquery";
    import deptSurvey from "./deptSurvey.vue";
    import tableindex from "@/components/22ys/tableqinghai/index.vue";
    import qksm1 from "@/components/22ys/qksmqinghai/qksm1.vue";
    import qksm2 from "@/components/22ys/qksmqinghai/qksm2.vue";
    import qksm3 from "@/components/22ys/qksmqinghai/qksm3.vue";
    import qksm4 from "@/components/22ys/qksmqinghai/qksm4.vue";
    import qksm5 from "@/components/22ys/qksmqinghai/qksm5.vue";
    import qksm6 from "@/components/22ys/qksmqinghai/qksm6.vue";
    import qksm7 from "@/components/22ys/qksmqinghai/qksm7.vue";
    import qksm8 from "@/components/22ys/qksmqinghai/qksm8.vue";
    import qksm9 from "@/components/22ys/qksmqinghai/qksm9.vue";
    import mcjs from "./mcjs.vue";
    import { getDivList, songshen, getPerformanceList } from "@/api/index.js";
    import { getBdata, getZoneTableProfile, zones } from "@/api/zone.js";

    export default {
        name: "pdfHtml",
        components: {
            deptSurvey,
            tableindex,
            qksm1,
            qksm2,
            qksm3,
            qksm4,
            qksm5,
            qksm6,
            qksm7,
            qksm8,
            qksm9,
            mcjs,
        },
        data() {
            return {
                divname: "",
                tableTitle: [],
                qksm: {},
                exprList: {},
                tables: [],
                isData: false,
                isPdf: true,
                //2022年数据
                moreDetails: [],
                dataJson: "",
                subjectCofig: "",
                threeLines: "",
                bdata: {},
                clearTimeSet: null,
                dialogVisible: false,
                typeText: '',
                isFinish: false,
                port: window.location.port
            };
        },
        async created() {
            await this.getDivData();
            this.format();//格式
            this.tableNum();//表格
            this.$nextTick(function () {
                if (eval(this.$route.query.isUpload) == true) {
                    this.upload();
                }
            });
        },
        updated() {
            this.$nextTick(function () {
                if (this.isData && document.getElementById("mcjs")) {
                    this.isChart();
                    this.isFinish = true
                }
            });
        },

        methods: {
            async getDivData() {
                let resZone = await zones({ code: hostCity, year: openYear, type: openType });
                if (resZone.status == 0) {
                    localStorage.setItem('city', resZone.zones[0].ad);
                }
                let res = await getDivList({ id: this.$route.query.divid });
                if (res.status == 0) {
                    this.typeText = res.type == 0 ? "单位" : "部门";
                    res.attachments = await this.getAttachments()
                    this.$store.commit('changeDivData', res)
                    this.moreDetails = res;
                    this.divname = res.divname;
                    this.qksm = res.qksm;
                    this.tables = res.tables;
                    let resBdata = await getBdata();
                    if (resBdata.status == 0) {
                        this.bdata = resBdata.bdata;
                        resBdata.bdata.forEach((e) => {
                            this.exprList[e.name] = this.preview(e.expr).result;
                        });
                        //let resConfig = await TableProfile()
                        let resProfile = await getZoneTableProfile();
                        if (resProfile.status == 0) {
                            let yop = "var bodyshow=true;"
                            let hop = eval(yop + resProfile.profile)
                            this.dataJson = hop.dataJson;
                            this.subjectCofig = hop.subjectCofig;
                            this.threeLines = hop.threeLines;
                            this.$store.commit("storageHop", hop);
                            this.tableTitle = hop.threeLines;
                            this.tableTitle.forEach((ele) => {
                                ele.title = ele.title.slice(ele.title.indexOf(".") + 1, ele.title.length);
                            });
                            this.isData = true;
                        }
                    }
                }
            },
            async getAttachments() {
                let list = []
                let nums = 1;
                let res = {}
                do {
                    res = await getPerformanceList({
                        id: this.$route.query.divid,
                        tags: "jxmbb,bmzxzj",
                        pageNumber: nums,
                        pageSize: 20,
                    });
                    list = list.concat(res.files);
                    nums++
                }
                while (res.files.length == 20)
                return list
            },
            preview(expr) {
                try {
                    let result = eval(this.makeEnvCode(this.tables) + expr);
                    return {
                        result,
                    };
                } catch (ex) {
                    return {
                        ex,
                    };
                }
            },
            isChart() {
                if (this.exprList["T2"].项目.filter((e) => e.value > 0).length > 0) {
                    document.getElementById("myChart2").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart2"),
                        "图1：收入预算情况",
                        this.exprList["T2"].项目
                            .filter((e) => e.value > 0)
                            .map((e) => {
                                return {
                                    name: e.name,
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }
                if (this.exprList["T3"].项目.filter((e) => e.value > 0).length > 0) {
                    document.getElementById("myChart3").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart3"),
                        "图2：支出预算情况",
                        this.exprList["T3"].项目
                            .filter((e) => e.value > 0)
                            .map((e) => {
                                return {
                                    name: e.name,
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }
                if (this.exprList["T4"].支出.filter((e) => e.value > 0).length > 0) {
                    document.getElementById("myChart4").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart4"),
                        "图3：财政拨款收支预算情况",
                        this.exprList["T4"].支出
                            .filter((e) => e.value > 0)
                            .map((e) => {
                                return {
                                    name: e.name + '支出',
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }
                if (this.num(this.exprList["T5"].总计) > 0) {
                    document.getElementById("myChart5").style.display = 'block'
                    this.barChart(
                        document.getElementById("myChart5"),
                        "图4：一般公共预算较上年变化情况",
                        [this.num(this.exprList["T5"].总计last), this.num(this.exprList["T5"].总计)])
                }
                if (this.exprList["T5"].leiItems.length > 0) {
                    document.getElementById("myChart6").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart6"),
                        "图5：一般公共预算当年拨款规模变化",
                        this.exprList["T5"].leiItems
                            .map((e) => {
                                return {
                                    name: e.name,
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }
                function canvasToImage(canvas) {
                    //新Image对象，可以理解为DOM
                    var image = new Image();
                    // canvas.toDataURL 返回的是一串Base64编码的URL，当然,浏览器自己肯定支持
                    image.src = canvas.toDataURL("image/png");
                    return image;
                }
                $("div.echart").each(function () {
                    if ($(this).find("canvas").first()[0]) {
                        let mycanvas = $(this).find("canvas").first()[0];//获取网页中的canvas对象
                        let img = canvasToImage(mycanvas);//将转换后的img标签插入到html中
                        console.log(mycanvas.parentNode)
                        mycanvas.parentNode.replaceWith(img)
                    }
                })
            },
            async upload() {
                if (this.$store.state.errors.length > 0) {
                    var str = ""
                    var i=1
                    for (let a of this.$store.state.errors) {
                        str += "<p>"+(i++)+'、'+a.message + "</p>"
                    }
                    this.$alert(str, '请检查', {
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true,
                        type: 'error',
                        callback: action => {
                            this.$router.push({
                                name: "部门概况",
                                query: { divid: this.$route.query.divid, sort: "one" },
                            });
                        }
                    });
                } else {
                    this.$alert('数据确认无误，请点击确定上传。', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: async action => {
                            let res = await songshen({ id: this.$route.query.divid });
                            if (res.status == 0) {
                                this.$message.success("上传成功");
                            }
                            this.$router.push({
                                name: "部门概况",
                                query: { divid: this.$route.query.divid, sort: "one" },
                            });                        }
                    });
                }
            },   
            format() {
                $("div.deptCon").each(function () {
                    let val = $(this).html().trim();
                    var f = "";
                    if (val) {
                        /*if (val.substring(val.length - 1, val.length) != "。") {
                            val = val + "。";
                        }*/
                        f = "<p  style='text-indent:2em !important'>" + val;
                        if (f) {
                            f = f.replace(/(\r|\n)\s{4}/g, '</p><p style="text-indent:2em !important">').replace(/[\r\n]/g, "</p><p>"); // 针对（换行+2个空格）
                            $(this).html(f);
                        }
                        f += "</p>";
                    } else {
                        f = "<p>未填</p>";
                    }
                    $(this).html(f);
                });
                $(".hide_pdf").each(function () {
                    $(this).remove();
                });
                $(".nogap").each(function () {
                    let html = $(this).html();
                    html = html
                        .replace(/[ \t]+?(?=\s)/g, "")
                        .replace(/(?<=\n)[ \t]*/g, "")
                        .replace(/\n/g, "")
                        .replace(/\s*/g, "");
                    html = html.replace(/pdata-v-/g, "p data-v-").replace(/bdata-v-/g, "b data-v-").replace(/h4data-v-/g, "h4 data-v-")
                    $(this).replaceWith(html);
                });
                var name = $("#pageTitle").text()
                var nameLength = name.length + 7
                $(".pageTitle").css("font-size", "32px");
                if (nameLength >= 22) {
                    $("#pageTitle").css("display", "block")
                    if (name.length > 22) {
                        $(".pageTitle").css("font-size", "23px");
                    } else if (name.length > 19) {
                        $(".pageTitle").css("font-size", "25px");
                    }
                } else if (nameLength > 16 && nameLength < 22) {
                    $("#pageTitle").html(name + '<br />')
                }

            },
            tableNum() {
                const that = this;
                if (document.getElementsByTagName("table").length < 8) {
                    that.clearTimeSet = setInterval(() => {
                        that.tableNum();
                    }, 1000);
                } else {
                    this.mentTable();
                    clearInterval(that.clearTimeSet);
                }
            },
            mentTable() {
                let that = this
                $(".table table").each(function (index, item) {
                    /**山东跨页加表头 */
                    //var sum = 0;
                    var title = $(this).siblings(".outtitle").prop("outerHTML");//标题
                    var tableheader = $(this).children("thead").prop("outerHTML");//表头
                    var titleheight = Number($(this).siblings(".outtitle").outerHeight(true))//标题高度
                    var tableheaderheight = Number($(this).children("thead").outerHeight(true))//表头高度
                    var sum = Number(tableheaderheight + titleheight)  //计算的初始值
                    var reduceheight = Number(tableheaderheight + titleheight) //每页需要减去的高度

                    var pageheight = 0
                    var tr = tableheader;
                    $(this).children(".thbody").find("tr").each(function (indextwo, itemtwo) {
                        tr += "<tr>" + $(this).html() + "</tr>";
                        sum = sum + $(this).outerHeight(true);
                        pageheight = Number(758 - reduceheight)//首次计算整页减去标题和表头的高度，下面初始化高度737+21
                        if (Number(sum) > pageheight) {
                            tr += '</table></div><div class="pdfpage landscape lineheight"><table>' + tableheader;
                            sum = tableheaderheight + Number(126);//高度加在reduceheight也一样，目的是为了控制第一页之后的每页高度，如果不加会消失5行
                            reduceheight = tableheaderheight
                        }
                    });
                    if (tr.substring(tr.length - 52) == '</table></div><div class="pdfpage landscape"><table>') {
                        tr = tr.substring(0, tr.length - 52);
                    }
                    var html = '<div class="pdfpage landscape">' + title + '<table>' + tr + "</table></div>";
                    $(this).parent().parent().replaceWith(html);
                    //如果只有一行数据隐藏头部
                    $('.lineheight').each(function () {
                        //if ($(this).find('tbody').children('tr').length == 1) {
                        //    $(this).find('tbody').siblings('thead').hide()
                        //}
                        if ($(this).find('tbody').length == 0) {
                            $(this).hide()
                        }
                    })
                });
                //如果只有一个注释且分页了，那么将注释一道上一页
                $(".pdfpage").each(function (index, item) {
                    if ($(this).find('tbody').children('tr').length == 1 && $(this).find('tbody').children('tr').text().indexOf('注') > -1) {
                        //$(this).prev('.pdfpage').find('tbody').children('tr').children('td').css({ 'line-height': '15px', 'height': '15px' })
                        //$(this).find('tbody').children('tr').children('td').css({ 'line-height': '15px', 'height': '15px' })
                        $(this).prev('.pdfpage').find('.outtitle').children('.headertitleone').css({ 'padding': '0' })
                        $(this).prev('.pdfpage').find('.outtitle').children('.headertitletwo').css({ 'line-height': '29px', 'height': '29px' })
                        $(this).prev('.pdfpage').find('.outtitle').children('.headertitlethree').css({ 'line-height': '29px', 'height': '29px' })
                        $(this).prev('.pdfpage').find('tbody').append($(this).find('tbody').children('tr').prop("outerHTML"))
                        $(this).hide()
                    }
                });

            },
        },
        //离开之前清除缓存
    };
</script>
<style>
    .left16 {
        padding-left: 1.6rem !important;
    }

    @page {
        size: a4;
        margin: 2cm -6cm 2cm 3cm;
    }

    @page rotated {
        size: landscape;
    }
    /*标题单独一页*/
    .landscapetitle {
        width: calc(100% - 9cm) !important;
        height: 25cm;
        position: relative;
    }
    /*横置*/
    .landscape {
        page: rotated;
        width: 100%;
        height: 25cm;
    }
    /*竖表*/
    .portrait {
        width: calc(100% - 9cm) !important;
    }

    .pdfpage .hide_pdf {
        display: none;
    }

    .pdfpage, .pdfpage .page {
        page-break-after: always;
    }

        .pdfpage .pageTitle {
            margin-top: 25vh;
            font-family: FangSong !important;
            font-weight: bold;
            /* font-size: 40px !important; */
            line-height: 2em;
            text-align: center;
            width: 100%;
            display: block;
        }
        /*针对部门概况的*/
		.pdfpage .tablebm tr td {
			font-size: 20px !important;
			line-height: 16px !important;
			height: 50px !important;
			padding-left: 2px;
			padding-right: 2px;
		}

    .qinghaitop {
        padding-top: 25% !important;
        font-family: FangSong !important;
        font-weight: bold !important;
    }

    .pdfpage h3 {
        font-size: 21px !important;
        width: 100%;
        text-align: left;
    }

    .pdfpage .catalogue {
        margin-top: 0px !important;
        text-align: center !important;
    }

    .pdfpage h2 {
        text-align: center;
        margin-top: 20%;
        font-size: 25px !important;
    }

    .pdfpage .echart {
        page-break-inside: avoid;
        margin: 0 auto;
        height: 400px;
        width: 14cm !important;
        border: 1px red solid;
        padding: 10px;
        display: none;
    }

    .pdfpage p,
    .pdfpage h4,
    .pdfpage b {
        font-size: 21px !important;
        font-family: FangSong !important;
        line-height: 2em !important;
    }

    .direList p {
        font-family: KaiTi !important;
        text-indent: 2em;
    }

    .pdfpage table .notes p {
        font-size: 13px !important;
        line-height: 14px !important;
        margin-bottom: 2px !important;
    }

    .pdfpage table .notes {
        padding-top: 3px;
    }

    .pdfpage h4,
    .pdfpage b {
        font-family: SimHei !important;
    }

    .pdfpage p {
        text-align: justify;
    }

    .pdfqksm {
        height: auto !important;
    }

        .pdfqksm p, .pdfqksm h4 {
            text-indent: 2em;
        }

    .pdfpage .mcjs p b {
        padding-left: 42px;
    }

    .pdfpage table {
        margin: 0 auto;
        width: 100%;
        border-spacing: 0;
        border-collapse: collapse;
        font-size: 18px;
        font-family: FangSong;
    }

        .pdfpage table thead {
            display: table-row-group;
        }

        .pdfpage table tr {
            /*page-break-before: always;
            page-break-after: always;
            page-break-inside: avoid;*/
        }

            .pdfpage table tr th,
            .pdfpage table tr td {
                border: 1px solid #808080;
                color: #000;
            }

            .pdfpage table tr th {
                height: 18px !important;
                line-height: 16px !important;
                font-size: 13px !important;
                font-weight: bold;
            }

            .pdfpage table tr td {
                font-size: 13px !important;
                line-height: 16px !important;
                height: 18px !important;
                padding-left: 2px;
                padding-right: 2px;
            }

            .pdfpage table tr .showright {
                font-size: 12px !important;
            }

            .pdfpage table tr .headerTitle {
                font-size: 18px !important;
            }

    .pdfpage .tableTips p {
        font-size: 13px !important;
        line-height: 14px !important;
    }

        .pdfpage .tableTips p .left16 {
            padding-left: 1.9rem !important;
        }

    #isData {
        color: #fff;
        opacity: 0;
    }

    .error {
        color: red;
    }

    .h3bottom {
        margin-bottom: 10px;
    }
</style>
